import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, vShow as _vShow, withDirectives as _withDirectives, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "row mr-3 pb-0" }
const _hoisted_2 = { class: "col-6" }
const _hoisted_3 = { class: "col-6" }
const _hoisted_4 = { class: "row mr-3 pb-0 pt-0" }
const _hoisted_5 = { class: "col-6" }

import { ref, watch } from 'vue'
import i18n from '@/lang/i18n';

const ERROR_KEY_PREFIX = 'initial_params.etc';

export default /*@__PURE__*/_defineComponent({
  __name: 'IniFileEtcSetting',
  props: ['modelValue','isOperationOffice', 'errors','isInstallationOffice'],
  emits: ['update:modelValue'],
  setup(__props, { emit: __emit }) {

const SELECT_ITEM_ETC_CONNECT =[
  {title: 'ON', value: 'ON'},
  {title: 'OFF', value: 'OFF'},
]
const SELECT_ITEM_ETC_DEVICE =[
  {title: 'FURUNO', value: 'FURUNO'},
  {title: 'DENSO', value: 'DENSO'},
  {title: 'MITSUBISHI', value: 'MITSUBISHI'},
]
const SELECT_ITEM_ETC_ROAD_SELECT =[
  {title: 'ON', value: 'AUTO'},
  {title: 'OFF', value: 'MANUAL'},
]
const props = __props;
const emit = __emit;

const form = ref(props.modelValue)

watch(props, () => {
  form.value = props.modelValue
}, { deep: true })
watch(form, () => {
  emit('update:modelValue', form.value)
}, { deep: true })

return (_ctx: any,_cache: any) => {
  const _component_v_card_title = _resolveComponent("v-card-title")!
  const _component_v_select = _resolveComponent("v-select")!
  const _component_v_card_text = _resolveComponent("v-card-text")!
  const _component_v_card = _resolveComponent("v-card")!

  return (_openBlock(), _createBlock(_component_v_card, { class: "my-4 pa-4" }, {
    default: _withCtx(() => [
      _createVNode(_component_v_card_title, { class: "headline" }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_unref(i18n).global.t('pages.vehicles.form.iniFileSetting.etc.title')), 1)
        ]),
        _: 1
      }),
      _createVNode(_component_v_card_text, null, {
        default: _withCtx(() => [
          _withDirectives(_createElementVNode("div", _hoisted_1, [
            _createElementVNode("div", _hoisted_2, [
              _createVNode(_component_v_select, {
                "hide-details": "auto",
                class: "small mt-2",
                label: _unref(i18n).global.t('pages.vehicles.form.iniFileSetting.etc.connect'),
                modelValue: form.value.connect,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((form.value.connect) = $event)),
                items: SELECT_ITEM_ETC_CONNECT,
                "error-messages": __props.errors[ERROR_KEY_PREFIX+'.connect'],
                clearable: false
              }, null, 8, ["label", "modelValue", "error-messages"])
            ]),
            _createElementVNode("div", _hoisted_3, [
              _createVNode(_component_v_select, {
                "hide-details": "auto",
                class: "small mt-2",
                label: _unref(i18n).global.t('pages.vehicles.form.iniFileSetting.etc.device'),
                modelValue: form.value.device,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((form.value.device) = $event)),
                items: SELECT_ITEM_ETC_DEVICE,
                "error-messages": __props.errors[ERROR_KEY_PREFIX+'.device'],
                clearable: false,
                disabled: __props.isInstallationOffice
              }, null, 8, ["label", "modelValue", "error-messages", "disabled"])
            ])
          ], 512), [
            [_vShow, !__props.isOperationOffice]
          ]),
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
              _createVNode(_component_v_select, {
                "hide-details": "auto",
                class: "small mt-2",
                label: _unref(i18n).global.t('pages.vehicles.form.iniFileSetting.etc.roadSelect'),
                modelValue: form.value.road_select,
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((form.value.road_select) = $event)),
                items: SELECT_ITEM_ETC_ROAD_SELECT,
                "error-messages": __props.errors[ERROR_KEY_PREFIX+'.road_select'],
                clearable: false,
                disabled: __props.isInstallationOffice
              }, null, 8, ["label", "modelValue", "error-messages", "disabled"])
            ])
          ])
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})